export enum ECrossSellingType {
    alsoBoughtArticles = "alsoBoughtArticles",
    alsoBoughtProductGroups = "alsoBoughtProductGroups",
    recommendedProductGroups = "recommendedProductGroups",
}

export type CrossSellingModalType = ECrossSellingType.alsoBoughtProductGroups | ECrossSellingType.recommendedProductGroups | null
